// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class TransactionTypeStatuses {
    public static readonly CONTRIBUTION: string = 'Contribution';
    public static readonly EXPENDITURE: string = 'Expenditure';
    public static readonly INKINDCONTRIBUTION: string = 'In Kind Contribution';
    public static readonly LOANRECEIVED: string = 'Loan Received';
    public static readonly VSR: string = 'VSR';
}
